import api from "../helpers/util";

// company id → backend tenant/schema name (matches server schemaMapper)
export const COMPANY_TENANT_MAP = {
  1: "careys",
  2: "bvm",
  3: "millmerran",
  4: "bvm_test",
};

export const getNlisSettings = (tenant) =>
  api.get(`/admin/customers/${tenant}/settings`);

export const saveNlisSettings = (tenant, data) =>
  api.put(`/admin/customers/${tenant}/settings`, data);